import { RadioCards, RadioCardsProps } from '@/components/GenericForm/RadioCards'
import Label from '@/components/Label'
import { Popover } from '@/components/TailwindUI/Popover'

export const responseTypeOptions = [
  {
    key: 'verbatim',
    title: 'Quoted text',
    description: 'Verbatim text directly from the source.',
    tooltip: 'Useful when precise and direct responses are desired.'
  },
  {
    key: 'rag',
    title: 'AI Summary',
    description: 'Summarized through Retrieval Augmented Generation (RAG).',
    tooltip: 'A more conversational response that uses relevant content from up to 5 sources.'
  }
]

const ResponseType = ({ value, onChange, formatProps, disabled = false }: Omit<RadioCardsProps, 'options'>) => {
  const details = (
    <div className="flex">
      <Label className={disabled ? 'text-sm font-normal text-zinc-500' : 'text-sm font-normal text-brand-400'}>
        What's the difference?
      </Label>

      <Popover
        as="div"
        background="brand"
        tooltipContent={
          <div className="relative grid gap-4 text-white">
            <span className="text-sm text-brand-100">Response Types</span>
            {responseTypeOptions.map(option => (
              <div key={option.key} className="flex items-start">
                <div>
                  <p className="text-sm font-black">{option.title}</p>
                  <p className="text-xs">{option.tooltip}</p>
                </div>
              </div>
            ))}
          </div>
        }
        className="inline-block"
      />
    </div>
  )
  return (
    <RadioCards
      formatProps={{ ...formatProps, details }}
      options={responseTypeOptions}
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
  )
}
export default ResponseType
